module.exports = __webpack_public_path__ + "img/svg.36b921f6.svg";